// styles
require('./amazonGiftCardConsentErrorModal.scss');
require('./amazonGiftCardConsentErrorModal.override.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const OKModal = require('components/commons/OKModal/OKModal');
const { formatText } = require('core/i18n').i18n;
//@constant
const {
    AMAZON_CONSENT_MODAL_ERROR,
    AMAZON_CONSENT_MODAL_OK,
    ACTION_EVENT_VIEW,
    AMAZON_CONSENT_MODAL
} = require('constants/tagging');
//@utils
const {
    recordLinkV2
} = require("../../../utilities/tagging");

// @assets
const IconError = require("assets/images/icon-error.svg");

class AmazonGiftCardConsentErrorModal extends React.Component {

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const {
            showModal
        } = this.props;

        if(showModal){
            this.handleRecordLink(ACTION_EVENT_VIEW);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            showModal
        } = this.props;

        if(prevProps.showModal !== showModal && showModal){
            this.handleRecordLink(ACTION_EVENT_VIEW);
        }
    }

    handleRecordLink(etiquetaEvento) {
        const customData = ({
            categoriaEvento: AMAZON_CONSENT_MODAL,
            accionEvento: AMAZON_CONSENT_MODAL_ERROR,
            etiquetaEvento
        });
        recordLinkV2(customData);
    }

    handleSubmit() {
        const { handleSubmit } = this.props;
        this.handleRecordLink(AMAZON_CONSENT_MODAL_OK);
        handleSubmit();
    }

    buildModalErrorContent() {
        const { title, description } = this.props;
        return (
            <ContentBox 
                title={title}
                titleSeparator={true}
                leftIcon={{icon: IconError}}
                customClassName="amazon-consents-error-modal"
                hasShadow={false}
            >
                <div className="amazon-consents-error-modal__wrapper">
                    <p className="amazon-consents-error-modal__text">{description}</p>
                </div>

            </ContentBox>
        );
    }

    buildModal() {
        const { showModal } = this.props;

        return (
            <OKModal
                content={this.buildModalErrorContent()}
                footerType="navigation"
                isOpen={showModal}
                customCloseButton={<div/>}
                shouldCloseOnOverlayClick={false}
                onPrimaryButtonClick={this.handleSubmit}
                hideHeader={true}
                primaryButtonText={formatText('amazonConsentModal-errorModalBtnText')}
                overlayClassName="amazon-consents-error-modal"
            />
        )
    }

    render() {
        return (
            <div>
                {this.buildModal()}
            </div>
        )
    }
}

AmazonGiftCardConsentErrorModal.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

module.exports = AmazonGiftCardConsentErrorModal;